'use strict'

const trapFocusHandlers = {};

const trapFocus = {   

    init(container, elementToFocus = container) {
        const elements = this.getFocusableElements(container);
        const first = elements[0];
        const last = elements[elements.length - 1];
    
        this.remove();
    
        trapFocusHandlers.focusin = (event) => {
            if (
                event.target !== container &&
                event.target !== last &&
                event.target !== first
            )
                return;
            document.addEventListener('keydown', trapFocusHandlers.keydown);
        };
    
        trapFocusHandlers.focusout = function() {
            document.removeEventListener('keydown', trapFocusHandlers.keydown);
        };
    
        trapFocusHandlers.keydown = function(event) {
            if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
            // On the last focusable element and tab forward, focus the first element.
            if (event.target === last && !event.shiftKey) {
                event.preventDefault();
                first.focus();
            }
    
            //  On the first focusable element and tab backward, focus the last element.
            if (
                (event.target === container || event.target === first) &&
                event.shiftKey
            ) {
                event.preventDefault();
                last.focus();
            }
        };
    
        document.addEventListener('focusout', trapFocusHandlers.focusout);
        document.addEventListener('focusin', trapFocusHandlers.focusin);
    
        elementToFocus.focus();
    },
    
    remove(elementToFocus = null) {
        document.removeEventListener('focusin', trapFocusHandlers.focusin);
        document.removeEventListener('focusout', trapFocusHandlers.focusout);
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      
        if (elementToFocus) elementToFocus.focus();
    },

    getFocusableElements(container) {
        return Array.from(
            container.querySelectorAll(
                "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
            )
        );
    }
}

export default trapFocus
